module.exports = __webpack_public_path__ + "static/leonelduarte-21a38afd2efdb8db9fe57ddcafbfe9f0.jpg";